module.exports = __webpack_public_path__ + "static/media/Star.785048c4.svg";